"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReconnectNotifications = void 0;
var _react = require("react");
var _logrocket = _interopRequireDefault(require("logrocket"));
var _reactSdk = require("@100mslive/react-sdk");
var _ToastManager = require("../Toast/ToastManager");
var _ToastConfig = require("../Toast/ToastConfig");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var notificationTypes = [_reactSdk.HMSNotificationTypes.RECONNECTED, _reactSdk.HMSNotificationTypes.RECONNECTING];
var notificationId = null;
var ReconnectNotifications = function ReconnectNotifications() {
  var notification = (0, _reactSdk.useHMSNotifications)(notificationTypes);
  (0, _react.useEffect)(function () {
    if ((notification === null || notification === void 0 ? void 0 : notification.type) === _reactSdk.HMSNotificationTypes.RECONNECTED) {
      _logrocket["default"].track("Reconnected");
      notificationId = _ToastManager.ToastManager.replaceToast(notificationId, _ToastConfig.ToastConfig.RECONNECTED.single());
    } else if ((notification === null || notification === void 0 ? void 0 : notification.type) === _reactSdk.HMSNotificationTypes.RECONNECTING) {
      _logrocket["default"].track("Reconnecting");
      notificationId = _ToastManager.ToastManager.replaceToast(notificationId, _ToastConfig.ToastConfig.RECONNECTING.single());
    }
  }, [notification]);
  return null;
};
exports.ReconnectNotifications = ReconnectNotifications;